module.exports = __webpack_public_path__ + "img/waistband_width.456b26b4.png";